import { Checkbox } from '@mui/material'
import { CheckboxProps } from '@mui/material/Checkbox'
import React, { ComponentType } from 'react'
import styled from 'styled-components'

export const StyledCheckbox = styled<ComponentType<CheckboxProps & { error: boolean }>>(({ error, ...rest }) => <Checkbox {...rest} />)`
  color: ${props => (props.error ? props.theme.palette.error.main : 'initial')};
`
